<template>
  <v-row justify="center">
    <v-menu
      bottom
      width="10px"
      rounded
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          class="mx-2"
        >
          <v-avatar
            color="botao_1"
            size="30"
          >
            <span class="white--text text-h7">
              <v-icon>mdi-account</v-icon>
            </span>
          </v-avatar>
        </v-btn>
      </template>

      <v-card>
        <v-list-item-content class="justify-center">
          <div class="mx-auto text-center">
            <v-avatar
              color="botao_1"
            >
              <span class="white--text text-h5">
                <v-icon dark>mdi-account</v-icon>
              </span>
            </v-avatar>

            <h3>{{ usuario.usuario }}</h3>

            <p class="text-caption mt-1">
              {{ usuario.email }}
            </p>

            <v-divider class="my-3"></v-divider>

            <v-switch
              v-model="$vuetify.theme.dark"
              class="mt-5 mx-2"
              color="botao_1"
              prepend-icon="mdi-theme-light-dark"
              label="Alterar tema"
              inset
              persistent-hint
              depressed
            ></v-switch>

            <v-divider class="my-3"></v-divider>

            <AlterarSenha @form-submit="senha_alterada" />

            <v-divider class="my-3"></v-divider>

            <v-btn
              color="botao_1"
              class="rounded-lg"
              @click="logout()"
              dark
              text
              depressed
              >SAIR</v-btn
            >

          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>
  </v-row>
</template>

<script>
import AlterarSenha from './components/AlterarSenha'
import { mapMutations } from 'vuex';

  export default {
    name: 'ProfileView',

    components: {
      AlterarSenha
    },

    props: {
      usuario: Object,
    },

    methods: {
      ...mapMutations(["CarregandoMutation"]),

      logout(){
        this.CarregandoMutation();

        localStorage.removeItem('access')
        localStorage.removeItem('refresh')
        this.$router.push('/');

        this.CarregandoMutation();
      },

      senha_alterada() {
        this.logout()
      },

    },

  }
</script>
